import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TdoUserConfigurationModel } from 'src/app/models/configuration/user/tdo-user-configuration.model';

@Component({
  selector: 'app-list-new-formatted-label-users',
  templateUrl: './list-new-formatted-label-users.component.html',
  styleUrls: ['./list-new-formatted-label-users.component.scss']
})
export class ListNewFormattedLabelUsersComponent {

  newFormattedUserList: TdoUserConfigurationModel[] =[];
  selectedFormattedLabelUser: TdoUserConfigurationModel;
  isLoading = true;

  constructor(
    public dialogRef: MatDialogRef<ListNewFormattedLabelUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.newFormattedUserList = data.ListFormattedUsers;
  }

  onRowSelected(user: TdoUserConfigurationModel) {
    this.selectedFormattedLabelUser = user;
    
  }



  createNewFormattedLabelUser() {
    this.dialogRef.close(this.selectedFormattedLabelUser);

  }
  cancel() {
    this.dialogRef.close(false);
  }

}
